import React from 'react'
import { Box, LinearProgress, Typography } from '@mui/material'
import PushPanel from './PushPanel'
import { ACTIVE_CAMPAIGN_STATUSES, fmtNum, POLL_INTERVAL_MS } from './pushUtils'
import type { Campaign } from './types'

const CampaignProgress: React.FC<{ campaign: Campaign }> = ({ campaign }) => {
    const active = ACTIVE_CAMPAIGN_STATUSES.includes(campaign.status)
    const processed = campaign.progress?.processed ?? campaign.counters?.processed ?? 0
    const total = campaign.progress?.total ?? campaign.counters?.sendable ?? 0
    const raw = typeof campaign.progress?.percent === 'number'
        ? campaign.progress.percent
        : total > 0 ? Math.round((processed / total) * 100) : 0
    const percent = Math.min(100, Math.max(0, raw))
    const freezing = campaign.status === 'FREEZING'

    return (
        <PushPanel sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#e0e0e0' }}>
                    {freezing ? 'Freezing audience...' : `${fmtNum(processed)} of ${fmtNum(total)} users processed`}
                </Typography>
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#ff6a3d' }}>{percent}%</Typography>
            </Box>
            <LinearProgress
                variant={freezing ? 'indeterminate' : 'determinate'}
                value={percent}
                sx={{ height: 8, borderRadius: 4, background: '#2a2a2a', '& .MuiLinearProgress-bar': { background: 'linear-gradient(90deg, #f2674a, #ff6a3d)', borderRadius: 4 } }}
            />
            {active && (
                <Typography sx={{ fontSize: 11, color: '#5a5a5a', mt: 1 }}>
                    Updating automatically every {POLL_INTERVAL_MS / 1000} seconds.
                </Typography>
            )}
        </PushPanel>
    )
}

export default CampaignProgress
